import { AtlasIcon, AtlasLabel, AtlasMarkerOptions, AtlasPopup, AtlasPosition } from '../../mu-atlas/interfaces/mu-atlas-types.interface';
import { AtlasMarker } from '../../mu-atlas/interfaces/mu-atlas-marker.interface';

declare var L;

export class MuMapLeafletMarker implements AtlasMarker {
  private data: any;
  private marker: any;
  private label: AtlasLabel;
  private icon: AtlasIcon;
  private popup: AtlasPopup;

  constructor(options: AtlasMarkerOptions) {
    this.marker = L.marker(options.position, { draggable: Boolean(options.draggable), autoPan: true });

    if (options.label) {
      this.setLabel(options.label);
    }
    if (options.icon) {
      this.setIcon(options.icon);
    }

    if (options.popup) {
      this.setPopup(options.popup);
    }
  }

  setPosition(position: AtlasPosition): void {
    this.marker.setLatLng(position);
  }

  getPosition(): AtlasPosition {
    return this.marker.getLatLng();
  }

  setLabel(label: AtlasLabel): void {
    this.label = label;

    const tooltipTable = document.createElement('div');
    Object.assign(tooltipTable.style, {
      position: 'absolute',
      transform: 'translate(-50%, -50px)',
      borderSpacing: '0px',
      display: 'table',
      height: '100px',
    });

    const tooltipCell = document.createElement('div');
    Object.assign(tooltipCell.style, {
      display: 'table-cell',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
      textAlign: 'center',
    });

    const customLabel = document.createElement('div');
    customLabel.style.color = this.label.color;
    customLabel.style.fontFamily = this.label.fontFamily;
    customLabel.style.fontSize = this.label.fontSize;
    customLabel.textContent = this.label.text;
    customLabel.className = this.label.className;

    tooltipCell.appendChild(customLabel);
    tooltipTable.appendChild(tooltipCell);
    this.marker.bindTooltip(tooltipTable, {
      direction: 'bottom',
      permanent: true,
      opacity: 1,
    });
  }

  setPopup(popup: AtlasPopup): void {
    this.popup = popup;

    const popupTable = document.createElement('div');
    popupTable.className = 'mu-map-popup';
    Object.assign(popupTable.style, {
      position: 'absolute',
      transform: 'translate(-50%, -0px)',
      borderSpacing: '0px',
      display: 'table',
      padding: '1rem',
      maxWidth: popup.maxWidth,
      minWidth: popup.minWidth,
      background: '#fff',
      border: '1px solid #D9D9D9',
      borderRadius: '12px',
    });

    const popupCell = document.createElement('div');
    Object.assign(popupCell.style, {
      display: 'table-cell',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
      textAlign: 'center',
    });
    popupCell.className = 'mu-map-popup-content';
    popupCell.id = 'mu-map-popup-content';
    const customPopup = document.createElement('div');
    customPopup.className = this.popup.className;
    customPopup.innerHTML = popup.content;
    const buttons = popup.buttons || [];
    popupCell.appendChild(customPopup);

    if (buttons.length > 0) {
      const customActionsPopup = document.createElement('div');
      customActionsPopup.className = `${this.popup.className}-actions`;
      Object.assign(customActionsPopup.style, {
        marginTop: '12px',
        display: 'flex',
        justifyContent: 'space-around',
      });
      buttons.forEach((element, index) => {
        const button = document.createElement('button');
        Object.assign(button.style, {
          cursor: 'pointer',
          border: 'none',
        });
        button.className = element.className;
        button.innerText = element.value;
        button.value = element.type;
        button.id = 'id-btn-marker-' + element.data.id.toString();

        customActionsPopup.appendChild(button);
      });
      popupCell.appendChild(customActionsPopup);
    }
    popupTable.appendChild(popupCell);
    this.marker.bindPopup(popupTable, {
      direction: 'bottom',
      maxWidth: popup.maxWidth,
      minWidth: popup.minWidth,
      closeButton: false,
      autoClose: popup.autoClose,
    });
    this.marker.on('click', e => {
      const itemClose = document.getElementById('close-popup-map');
      if (itemClose) {
        itemClose.addEventListener('click', () => {
          this.marker.closePopup();
        });
      }
    });
    return this.marker;
  }
  getPopup(): AtlasPopup {
    return this.popup;
  }
  getLabel(): AtlasLabel {
    return this.label;
  }

  setIcon(icon: AtlasIcon): void {
    this.icon = icon;

    const customIcon = L.icon({
      iconUrl: this.icon.url,
      iconSize: [this.icon.size.width, this.icon.size.height],
      iconAnchor: [this.icon.anchor.x, this.icon.anchor.y],
      tooltipAnchor: [this.icon.anchor.x * -1 + this.icon.labelOrigin.x, this.icon.anchor.y * -1 + this.icon.labelOrigin.y],
      className: icon.className || '',
    });

    if (this.marker.getElement()?.classList.contains('leaflet-marker-draggable')) {
      this.marker.getElement().src = this.icon.url;
    } else {
      this.marker.setIcon(customIcon);
    }
  }

  getIcon(): AtlasIcon {
    return this.icon;
  }

  addListener(event: string, fn: (event: any) => void): void {
    this.marker.on(event, fn);
  }

  removeAllListeners(): void {
    this.marker.off();
  }

  setValues(values: any): void {
    this.data = values;
  }

  get(key: string): any {
    return this.data?.[key];
  }

  getElementForMap() {
    return this.marker;
  }
}
